<template>
    <w-dialog :dialogShow="state" @handleClose="handleClose" :top="11">
        <div slot="content" class="version-content">
            <img src="https://files.wondercv.com/ios/ios-update-dialog.png" 
            @click="updateVersion">
        </div>
    </w-dialog>
</template>

<script>
    import WDialog from '@/components/global/w-dialog'
    import {envMixin} from "../../assets/js/mixin/global"
    export default {
        name: 'update-version',
        props: {
            state: {
                type: Boolean,
                default: false
            },
            versionData: {
                type: Array,
                default: () => [
                    {title: '简历编辑改版！', desc: '优化简历编辑体验，更新App立即查看'},
                    {title: '修复已知问题', desc: '体验更流畅，操作更方便'}
                ]
            },
            maskClose: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {

            }
        },
        mixins:[envMixin],
        mounted() {
        },
        computed: {},
        watch: {},
        components: {
            WDialog
        },
        methods: {
            updateVersion() {
                window.location.href = 'https://itunes.apple.com/cn/app/%E8%B6%85%E7%BA%A7%E7%AE%80%E5%8E%86-%E5%AE%9E%E4%B9%A0%E6%89%BE%E5%B7%A5%E4%BD%9C%E5%BF%85%E5%A4%87/id1327732591?mt=8l'
            },
            handleClose() {
                if (this.maskClose) {
                    this.$emit('maskClose')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .version-content {
        width: 100vw;
        text-align: center;
        position: relative;
        img {
            width: 90%;
            margin: 80px auto;
        }
    }
</style>
